<template>
  <span><b>Error</b> - a beautiful freebie for every web developer.</span>
</template>
<script>
  export default {
    props: {
      error_message: String
    }
  }
</script>
<style>
</style>
